module.exports = __webpack_public_path__ + "media/stadium_drum_beat.c0df0e3d.mp3";